export enum OrderTypes {
  GROCERIES = 'GROCERIES',
  ENTERTAINING = 'ENTERTAINING',
  GROCERIES_ENTERTAINING = 'GROCERIES_ENTERTAINING',
}
